export enum DocumentResponse {
  FileName = 'FileName',
  NoError = 'NoError',
}
